import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 50
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.1
    }
  }
}

export default function SectionWrapper({
  children,
  className = '',
  id,
  gradient = 'from-dark-primary to-dark-secondary',
  withParticles = false
}) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-50px' })

  return (
    <motion.section
      ref={ref}
      id={id}
      className={`section-container scroll-section bg-gradient-to-b ${gradient} ${className} min-h-[100dvh] px-3 sm:px-4 md:px-6 py-8 sm:py-12 md:py-16`}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      variants={sectionVariants}
    >
      {withParticles && <ParticleBackground />}
      <div className="relative z-10 w-full max-w-6xl mx-auto">
        {children}
      </div>
    </motion.section>
  )
}

function ParticleBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(20)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 rounded-full bg-primary-pink/20"
          initial={{
            x: Math.random() * 100 + '%',
            y: '100%',
            scale: Math.random() * 0.5 + 0.5
          }}
          animate={{
            y: '-100%',
            x: `calc(${Math.random() * 100}% + ${Math.sin(i) * 50}px)`
          }}
          transition={{
            duration: Math.random() * 10 + 10,
            repeat: Infinity,
            ease: 'linear',
            delay: Math.random() * 5
          }}
        />
      ))}
    </div>
  )
}
